var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useMemo, useState } from 'react';

import { useLoaderData } from 'react-router-dom';
import * as pxParagraphApi from "../../../api/paragraphExtractor/paragraphs";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Table, Button } from "../../../Components/UI";
import { Sidepanel } from "../../../Components/UI/Sidepanel";

import { Translate, I18NApi } from "../../../../I18N";

import { RequestParams } from "../../../../utils/RequestParams";
import { tableBuilder } from "./components/PXParagraphTableElements";
import { TableTitle } from "./components/TableTitle";

import { getTemplateName } from "./utils/getTemplateName";
import { ViewParagraph } from "./components/ViewParagraph";
import { templatesAtom } from "../../../atoms";
import { useAtomValue } from 'jotai';

const formatParagraphData = (
paragraphs,
templates,
languagePool) =>

paragraphs.map((paragraph) => {
  const templateName = getTemplateName(templates, paragraph.templateId);
  const languages = paragraph.languages.map((language) => {
    const { label = language } = languagePool.find((pool) => pool.key === language) || {};
    return label;
  });
  return _objectSpread(_objectSpread({},
  paragraph), {}, {
    rowId: paragraph._id || '',
    templateName,
    languages });

});

const PXParagraphDashboard = () => {
  const {
    paragraphs = [],
    extractorId,
    languages = []
  } = useLoaderData();






  const [sidePanel, setSidePanel] = useState(false);
  const [paragraphOnView, setParagraphOnView] = useState(undefined);
  const [paragraphInfo, setParagraphInfo] = useState(undefined);
  const templates = useAtomValue(templatesAtom);

  const pxParagraphData = useMemo(
    () => formatParagraphData(paragraphs, templates, languages),
    [paragraphs, templates, languages]
  );

  useEffect(() => {
    if (pxParagraphData.length) {
      setParagraphInfo(pxParagraphData[0]);
    }
  }, [pxParagraphData]);

  const openSidePanel = (id) => {
    setSidePanel(true);
    const targetParagraph = pxParagraphData.find((paragraph) => paragraph._id === id);
    setParagraphOnView(targetParagraph);
  };

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-paragraph-extractor",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: "Paragraphs",
      path:
      new Map([
      ['Paragraph extraction', '/settings/paragraph-extraction'],
      ['Entities', `/settings/paragraph-extraction/${extractorId}/entities`]]
      ) }

    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: pxParagraphData,
      columns: tableBuilder({ onViewAction: openSidePanel }),
      header:
      paragraphInfo && /*#__PURE__*/
      _jsx(TableTitle, {
        items: [
        paragraphInfo.templateName,
        paragraphInfo.document,
        paragraphInfo.languages.join(', ')] }

      ),


      defaultSorting: [{ id: '_id', desc: false }] }
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      withOverlay: true,
      isOpen: sidePanel,
      closeSidepanelFunction: () => {
        setSidePanel(false);
      },
      title: /*#__PURE__*/
      _jsx("span", { className: "text-base font-semibold text-gray-500 leading-6 uppercase" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Entity")
      ) }, void 0, /*#__PURE__*/


    _jsx(Sidepanel.Body, {}, void 0,
    paragraphOnView && /*#__PURE__*/_jsx(ViewParagraph, { paragraphData: paragraphOnView })
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3 border-t" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 justify-end" }, void 0, /*#__PURE__*/
    _jsx(Button, { size: "small", styling: "outline" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "View entity")
    )
    )
    )
    )
    ));

};

const PXParagraphLoader =
(headers) =>
async ({ params: { extractorId = '' } }) => {
  const [paragraphs = [], languages] = await Promise.all([
  pxParagraphApi.getByParagraphExtractorId(extractorId),
  I18NApi.getLanguages(new RequestParams({}, headers))]
  );
  return { paragraphs, extractorId, languages };
};

export { PXParagraphDashboard, PXParagraphLoader };